import React from 'react';
import { Card, CardHeader, CardContent, Stack } from '@mui/material';
import { ContactDataForm } from '../../ContactDataForm';

const ParentAndParticipantForm = ({ formik }) => (
  <Stack justifyContent="space-between" m={2} spacing={2}>
    <Card style={{ flex: '1 1 50%' }}>
      <CardHeader title="Dane uczestnika" sx={{ mt: -1 }} />
      <CardContent>
        <ContactDataForm
          formik={formik}
          type="participant"
          name="participant_name"
          streetAddress="participant_street_address"
          postalCode="participant_postal_code"
          city="participant_city"
          birthDate="participant_birth_date"
          nipOrPesel="participant_pesel"
          gender="participant_gender"
        />
      </CardContent>
    </Card>
    <Card style={{ flex: '1 1 50%' }}>
      <CardHeader title="Dane opiekuna" sx={{ mt: -1 }} />
      <CardContent>
        <ContactDataForm
          formik={formik}
          type="guardian"
          name="guardian_name"
          streetAddress="guardian_street_address"
          postalCode="guardian_postal_code"
          city="guardian_city"
          nipOrPesel="guardian_nip"
          phoneNumber="guardian_phone"
          email="guardian_correspondence_email"
        />
      </CardContent>
    </Card>
  </Stack>
);

export default ParentAndParticipantForm;
